.label {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  vertical-align: middle;
}
.icon {
  display: inline-block;
  flex-shrink: 0;
  width: 1.25rem;
  object-fit: contain;
}
